import { createStyles, makeStyles } from '@material-ui/core/styles';
import { textColorMap } from '@/utils/constants';

const PowerAppsStyles = createStyles({
  root: { position: 'relative', width: '100%' },
  iframe: {},
  loaderBoxContainer: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sessiontLostMessage: {
    color: textColorMap.dark.default,
  },
});

export default makeStyles(PowerAppsStyles, { name: 'PowerApps' });
